import { Provider } from './context';
import { CompanyStatsContextProps as ContextProps } from './types';

export const CompanyStatsProvider = ({ children, value }: ContextProps) => {
  return (
    <Provider
      value={{
        employees: value?.employees,
        offices: value.offices,
        hoveredItem: value?.hoveredItem,
        statsType: value.statsType,
        handleChangeStats: value?.handleChangeStats,
      }}
    >
      {children}
    </Provider>
  );
};
